// intro-app/account/newPassword.js

(function () {
    'use strict';
    var controllerId = 'newPassword';
    angular.module('intro-app').controller(controllerId, ['datacontext', '$translate', newPasswordFn]);

    function newPasswordFn(datacontext, $translate) {
        var vm = this;
        vm.error = null;

        resetObj();
        vm.newPassword = newPassword;

        vm.lingua = $translate.use();

        function newPassword() {
            vm.error = null;
            return datacontext.account_newPassword(vm.item).then(function (response) {
                if (response.status == 200) {
                    window.location = "/home/index";
                }
                else {
                    vm.error = response.data;
                }
            });
        }

        function resetObj() {
            const urlParams = new URLSearchParams(window.location.search);
            vm.item = {
                "Username": urlParams.get('username') || urlParams.get('Username') || urlParams.get('USERNAME'),
                "UID": urlParams.get('uid') || urlParams.get('Uid') || urlParams.get('UID'),
                "Password": "",
                "Password2": ""
            };
        }
    }
})();